export default __webpack_public_path__ + "static/5-check-points_final-ea6607b2cfe259f5e2950ba63e703e8d.png";